import Contactus from "../../components/contactUs/contactUs";
import styles from "./contactUs.module.css";

const ContactUs = () => {
  return (
    <div>
      <Contactus></Contactus>
    </div>
  );
}
 
export default ContactUs;
